// extracted by mini-css-extract-plugin
module.exports = {"footer":"xKhux_","logoutButton":"_3Myj68"};